/**
 * Cửa vào màn chọn ảnh: đọc token từ đường dẫn.
 *
 * Cùng lý do với màn xem album — khách mở trên máy của chính mình và cần giữ
 * link để quay lại, nên token KHÔNG bị lau khỏi thanh địa chỉ.
 */
import { useParams } from "@tanstack/react-router";
import { PhotoSelectionPage } from "./PhotoSelectionPage";
import { PublicPageScroll } from "@/components/PublicPageScroll";

export function PhotoSelectionRoute() {
  const { token } = useParams({ from: "/chon-anh/$token" });
  return (
    <PublicPageScroll>
      <PhotoSelectionPage token={token} />
    </PublicPageScroll>
  );
}
